import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDropDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.62507 3.25H2.37507C2.23257 3.25 2.10207 3.33075 2.03882 3.45875C1.97557 3.5865 1.99057 3.73925 2.07682 3.8525L5.70182 8.6025C5.77307 8.6955 5.88307 8.75 6.00007 8.75C6.11707 8.75 6.22707 8.6955 6.29807 8.6025L9.92307 3.8525C10.0096 3.73925 10.0243 3.5865 9.96107 3.45875C9.89807 3.33075 9.76757 3.25 9.62507 3.25Z", fill: "white" }));
const ForwardRef = forwardRef(SvgArrowDropDown);
export default ForwardRef;
